// Markdown payloads that render the animated "thinking" loader inside the chat.
// Kept in their own module so ChatProvider can reference them without importing
// the chat-message component tree.
export const THINKING_TEMPLATE = '```json+ThinkingLoader\n{}\n```';
export const RETRYING_TEMPLATE = '```json+ThinkingLoader\n{"message": "Taking more time than usual..."}\n```';
